module.exports = __webpack_public_path__ + "static/img/loading.3016b11.gif";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sapporo/images/loading.gif
// module id = qXmD
// module chunks = 0